<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<h1 class="plm_hd"><a href="#/Text/PROV_contents">﻿Select bibliography</a></h1>
<p class="biblio1">Anderson, B. W., <em class="italic">The Living World of the Old Testament</em> (Longmans, 2nd edition 1967).</p>
<p class="biblio1">Anderson, G. W., <em class="italic">A Critical Introduction to the Old Testament</em> (Duckworth, 1959).</p>
<p class="biblio1">Clements, R. E., <em class="italic">Wisdom in Theology</em> (Paternoster, 1992).</p>
<p class="biblio1">Coughenour, R. A., ‘The Wisdom Literature of the Bible’, and other unpublished documents, kindly made available to me by the author.</p>
<p class="biblio1">Goldingay, J., ‘Proverbs’, in the <em class="italic">New Bible Commentary</em> (IVP, 1995 edition).</p>
<p class="biblio1">Groome, T. H., <em class="italic">Christian Religious Education</em> (Harper and Row, 1981).</p>
<p class="biblio1">Henry, Matthew, <em class="italic">Exposition of the Old and New Testaments</em> (1708–10, various editions).</p>
<p class="biblio1">Horton, R. F., <em class="italic">The Book of Proverbs</em>, The Expositor’s Bible (Hodder and Stoughton, 1911).</p>
<p class="biblio1">Hubbard, D. A., <em class="italic">Proverbs</em>, The Communicator’s Commentary (Word, 1989).</p>
<p class="biblio1">Kidner, Derek, <em class="italic">Proverbs</em>, Tyndale Old Testament Commentaries (IVP, 1964).</p>
<p class="biblio1">__ <em class="italic">The Wisdom of Proverbs, Job and Ecclesiastes</em> (IVP, 1985).</p>
<p class="biblio1">McKane, W., <em class="italic">Proverbs: A New Approach</em>, Old Testament Library (SCM, 1975).</p>
<p class="biblio1">Perry, T. A., <em class="italic">Wisdom Literature and the Structure of Proverbs</em> (Pennsylvania State University Press, 1993).</p>
<p class="biblio1">Scott, R. B. Y., <em class="italic">Proverbs; Ecclesiastes</em>, Anchor Bible (Doubleday, 1965).</p>
<p class="biblio1">Toy, C. H., <em class="italic">The Book of Proverbs</em>, International Critical Commentary (T. and T. Clark, 1899).</p>
<p class="biblio1">Whybray, R. N., <em class="italic">Proverbs</em>, New Century Bible Commentary (Marshall Pickering, 1994).</p>
<p class="biblio1">__ <em class="italic">Wisdom in Proverbs</em>, Studies in Biblical Theology 45 (SCM, 1965).</p></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PROV_bibliog.vue?63a1a9a4